const getCompetitionPayload = ({ slug, competitionName }) => ({
  competition_slug: slug,
  competition_name: competitionName,
})

export default (tracker) => ({
  viewed(competition) {
    tracker.track('Competition Viewed', getCompetitionPayload(competition))
  },

  formSubmitted(competition) {
    tracker.track('Competition Form Submitted', getCompetitionPayload(competition))
  },

  verified(competition) {
    tracker.track('Competition Verified', getCompetitionPayload(competition))
  },
})
